<style scoped lang="scss">

</style>

<template>
  <div>
    <div ref="notice-modal" id="notice-modal" esc-close="false" class="uk-modal">
      <div class="uk-modal-dialog uk-modal-dialog-blank">
        <button class="uk-modal-close uk-close" type="button"></button>
        <div id="pre-qualify-box" class="uk-grid uk-flex-middle">
          <div class="uk-width-1-6 uk-width-medium-1-3 uk-height-viewport uk-cover-background uk-row-first "
               style="background-image: url('/images/home-top-bg-mobile.jpg');"></div>
          <div class="uk-width-5-6 uk-width-medium-2-3 uk-height-1-1 uk-overflow-container">
            <div class="uk-width-9-10 uk-align-center uk-margin-small-top uk-vertical-align-middle">
              <p class="uk-visible-small"><br/>
              </p>
              <h2 class="uk-text-center">{{ __('landing.prequal_everyone_must_prescreen') }}</h2>
              <button id="pre-qualify-form-button" @click="showFormModal"
                 class="uk-button uk-button-primary uk-button-large uk-width-9-10 uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade"><i
                  class="uk-icon-pencil-square-o"></i> {{ __('landing.click_here_prescreen') }}</button>
              <hr/>
              <a href="#document-check-list" data-uk-modal
                 class="uk-button uk-button-secondary uk-button uk-width-9-10 uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade"><i
                  class="uk-icon-check-square-o"></i> {{ __('landing.document_checklist') }}</a>
              <p class="uk-animation-fade uk-width-9-10" v-html="__('landing.prequal_checklist')"></p>
              <hr/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="pre-qualify-form" id="pre-qualify-form-vue" class="uk-modal"
         uk-modal="{bgClose:false, 'esc-close': false, keyboard: false}">
      <div class="uk-modal-dialog uk-modal-dialog-blank">
        <div class="uk-grid uk-flex-middle">
          <div class="uk-width-1-10 uk-height-viewport"> &nbsp;</div>
          <div v-if="showDeclined" class="uk-width-8-10 uk-width-medium-5-10 ">
            <div class="uk-grid uk-text-center">
              <div class="uk-width-1-1 ">
                <div class="uk-width-9-10 uk-align-center uk-margin-small-top">
                  <p class="uk-visible-small"><br/>
                  </p>
                  <div v-if="env.PROGRAM_NAME === 'RentHelpMN'">
                    <h2 class="uk-width-1-1 uk-align-center uk-animation-fade uk-margin-small-top">{{ __('landing.we_are_sorry', {program_name: program.program_name}) }}</h2>
                    <hr/>
                    <div id="not-qualified-note" class="uk-width-9-10 uk-align-center"></div>
                    <p class="uk-animation-fade uk-width-9-10 uk-align-center">{{ __('landing.based_on_answer', {program_abbreviation: program.program_abbreviation}) }}</p>
                    <h3 class="uk-width-small-1-1 uk-margin-bottom uk-align-center" v-html="__('landing.please_visit')"></h3>
                    <p class="uk-animation-fade uk-width-9-10 uk-align-center">{{ __('landing.call_us_at',{public_email: env.PUBLIC_EMAIL, public_phone: env.PUBLIC_PHONE}) }}</p>
                  </div>
                  <div v-else>
                    <h2 class="uk-width-1-1 uk-align-center uk-animation-fade uk-margin-small-top">{{ __('landing.we_are_sorry', {program_name: program.program_name}) }}</h2>
                    <hr/>
                    <div id="not-qualified-note" class="uk-width-9-10 uk-align-center"></div>
                    <p class="uk-animation-fade uk-width-9-10">{{ __('landing.based_on_answer', {program_abbreviation: program.program_abbreviation}) }}</p>
                    <h3 class="uk-width-small-1-1 uk-margin-bottom"><a v-if="env.HELP_QUALIFY_LINK" :href="env.HELP_QUALIFY_LINK" target="_blank">{{ __('landing.help_i_not_qualify') }}</a><span v-else>{{ __('landing.help_i_not_qualify') }}</span></h3>
                    <p class="uk-animation-fade uk-width-9-10">
                      {{ __('landing.call_us_at',{public_email: env.PUBLIC_EMAIL, public_phone: env.PUBLIC_PHONE}) }}
                    </p>
                  </div>

                </div>

                <div class="uk-width-1-1 uk-text-center">
                  <button class="uk-button uk-button-primary" @click="setDisqualified">Close</button>
                </div>
              </div>
            </div>
          </div>


          <div id="field-partner-questions" v-else-if="program.settings['show-program-partner-form'] && showFieldPartnerForm" class="uk-width-9-10 uk-width-medium-5-10">
            <div class="uk-width-8-10">
              <div class="uk-text-center">
                <h2>{{ __('landing.working_with_partner') }}</h2>
                <div class="uk-width-9-10 uk-align-center" v-if="usingFieldPartner === null">
                  <button
                      @click="setUsingFieldPartner(true)"
                      class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade">
                    <i class="uk-icon-square-o"></i> {{ __('global.yes') }}</button>
                  <button
                      @click="setUsingFieldPartner(false)"
                      class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"><i
                      class="uk-icon-square-o"></i> {{ __('global.no') }}</button>
                </div>

                <div class="uk-grid uk-text-left" v-else>

                   <div class="uk-width-1-1 uk-margin-bottom">
                     <validated-section :errors="errors" field="pid">
                       <label>{{ __('landing.field_partner_id') }}</label>
                       <input type="text" class="uk-form-large uk-width-1-1" :placeholder="__('landing.field_partner_id')" v-model="fieldPartnerId" autofocus>
                     </validated-section>
                   </div>

                  <div class="uk-width-small-1-1 uk-width-medium-1-2">
                    <button @click="checkFieldPartnerId()" :disabled="fieldPartnerLoading" class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 ">
                      <span v-if="fieldPartnerLoading">{{ __('landing.checking_id') }}</span>
                      <span v-else>{{ __('landing.check_id_continue') }}</span>
                    </button>
                  </div>
                  <div class="uk-width-small-1-1 uk-width-medium-1-2">
                    <button @click="setUsingFieldPartner(false)" class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1">
                      {{ __('landing.continue_without_partner') }}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>


          <div id="pre-qual-questions" class="uk-width-8-10 uk-width-medium-5-10 " v-else>
            <a name="questions-top"></a>
            <div class="uk-width-9-10 uk-align-center" v-if="!!currentQuestion">
              <p class="uk-visible-small"><br/></p>
              <h2 class="uk-text-center">{{ __('global.question') }} {{ currentQuestion.number }}:</h2>
              <div v-if="currentQuestion.type === 'income'">
                <div v-if="isHomeless" class="uk-text-center uk-margin"><span>{{  __('landing.if_currently_homess') }}</span></div>
                <income-question
                  :states="states"
                  :counties="counties"
                  :program="program"
                  :is-homeless="isHomeless"
                  @proxyUpdated="form.fact_based_proxy = $event"
                  @addressVerified="updateVerifiedAddress">
                </income-question>
              </div>

              <div v-else-if="currentQuestion.type === 'hardship'">
                <hardship-question :program="program"
                                   :question="currentQuestion"
                                   @answer="answerHardshipQuestion(currentQuestion.number, $event.answer, $event.programId)"
                ></hardship-question>
              </div>

              <div v-else class="uk-text-center" v-html="currentQuestion.body"></div>
              <hr/>
              <div class="uk-width-9-10 uk-align-center" v-if="(currentQuestion.type !== 'income' && currentQuestion.type !== 'hardship') || verifiedAddress !== null">
                <button class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
                   @click="answerQuestion(currentQuestion.number,'yes');" id="prequal_yes_answer_btn">
                  <i class="uk-icon-square-o"></i> {{ __('global.yes') }}</button>
                <button class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
                   @click="answerQuestion(currentQuestion.number,'no');"><i class="uk-icon-square-o"></i> {{ __('global.no') }}</button>
              </div>
              <div v-if="currentQuestion.type == 'income' && verifiedAddress == null">
                <h3 class="uk-text-center">Please Enter a Valid Address.</h3>
              </div>
            </div>

            <div v-if="showForm && !application">
              <p class="uk-visible-small"><br/></p>
              <template v-if="env.LANG_KEY === 'orera_'">
                <h2 class="uk-text-left">{{ __(`landing.you_are_prequalified`)}}</h2>
                <p class="uk-text-left" v-html="__('landing.based_on_your_answer')"/>
              </template>
              <template v-else>
                <h2 class="uk-text-left">{{ __('global.congrats')}}</h2>
                <p class="uk-text-left" v-html="__('landing.based_on_your_answer')"/>
              </template>


              <hr/>
              <!-- DEV NOTE: be careful to include all the question-X where x is the question number -->
              <form autocomplete="off" class="uk-form uk-width-1-1 uk-align-center uk-grid" id="question-9-ssns"
                    name="question-9-ssns" onsubmit="return false;">
                <input type="hidden" name="program_slug" :value="program.slug"/>

                <p class="uk-margin-bottom">
                  {{ __('landing.complete_remainig_section', {program_abbreviation: program.program_abbreviation})}}
                </p>

                <template v-if="env.LANG_KEY == 'orera_'">
                  <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                    <p v-if="program.slug === 'orera'">{{ __('landing.to_apply_you_will')}}</p>
                    <p v-else>To apply, you will need to have the following:</p>

                    <strong>{{ __('landing.verify_identity')}}</strong>
                    <p>
                      <small v-html="`( ${__('landing.verify_identity_hh_restriction')} )`"></small>
                    </p>
                    <ul>
                      <li v-for="index in 11" v-bind:key="index">
                        {{ __('landing.verify_identity_' + index)}}
                      </li>
                    </ul>

                    <strong>{{ __('landing.verify_income')}}</strong>
                    <p>
                      <small v-html="`( ${__('landing.verify_income_hh_restriction')} )`"></small>
                    </p>
                    <ul>
                      <li v-for="index in 11" v-bind:key="index">
                        {{ __('landing.verify_income_' + index)}}
                      </li>
                    </ul>


                    <strong>{{ __('landing.verify_residence')}}</strong>
                    <p>
                      <small v-html="`( ${__('landing.verify_residence_restriction')} )`"></small>
                    </p>
                    <ul>
                      <li v-for="index in 5" v-bind:key="index">
                        {{ __('landing.verify_residence_' + index)}}
                      </li>
                    </ul>


                    <strong>{{ __('landing.verify_rent_owed') }}</strong>
                    <p>
                      <small v-html="`( ${__('landing.verify_rent_owed_restriction')} )`"></small>
                    </p>
                    <ul>
                      <li>
                        {{ __('landing.verify_rent_owed_1') }}
                      </li>
                      <li>
                        {{ __('landing.verify_rent_owed_2') }}
                        <ul>
                          <li v-for="index in 4" v-bind:key="index">
                            {{ __('landing.verify_rent_owed_2_' + index) }}
                          </li>
                        </ul>
                      </li>
                    </ul>

                    <strong>{{ __('landing.verify_utility') }}</strong>
                    <ul>
                      <li>
                        {{ __('landing.verify_utility_1') }}
                      </li>
                    </ul>

                    <p>
                      {{ __('landing.alternative_options_for_document') }}
                    </p>
                    <p>
                      {{ __('landing.note_your_doc') }}
                    </p>

                    <p v-html="__('landing.need_additional_assistance')"></p>

                  </div>
                </template>

                <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                  <h3>* {{ __('global.head_of_hh') }}</h3>
                </div>
                <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                  <div class="uk-grid">
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <label>{{ __('global.first_name') }} *</label>
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="first_name">
                        <input v-model="form.hoh.first_name" class="uk-width-1-1 uk-form-large" type="text"
                               :placeholder="__('global.first_name')" required>
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="last_name">
                        <label>{{ __('global.last_name') }} *</label>
                        <input v-model="form.hoh.last_name" class="uk-form-large uk-width-1-1" type="text"
                               :placeholder="__('global.last_name')" required>
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1" v-if="env.AUTH_TYPE === 'username'">
                      <hr />
                      <small>{{ __('landing.please_write_down')}}</small> <br/><br/>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom" v-if="env.AUTH_TYPE === 'username'">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="username">
                        <label>{{ __('global.username') }} *</label>
                        <input v-model="form.hoh.username" class="uk-form-large uk-width-1-1" type="text"
                               @change="checkForDuplicateUsername(form.hoh.username)"
                               :placeholder="__('global.username')" required>
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom" v-if="env.AUTH_TYPE === 'username'">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="username_confirmation">
                        <label>{{ __('global.confirm') }} {{ __('global.username') }} *</label>
                        <input v-model="form.hoh.username_confirmation" class="uk-form-large uk-width-1-1" type="text"
                               :placeholder="__('global.confirm') + ' ' + __('global.username')" required>
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1" v-if="env.AUTH_TYPE === 'username'">
                      <hr />
                      <small>Please enter your email address, and/or phone number.</small><br/><br/>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="email">
                        <label>Email {{ env.AUTH_TYPE === 'email' ? '*' : '' }}</label>
                        <input v-model="form.hoh.email" class="uk-form-large uk-width-1-1" type="text"
                               @change="checkForDuplicateEmailAddress(form.hoh.email)"
                               placeholder="HH's Email" >
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="email_confirmation">
                        <label>Confirm Email {{ env.AUTH_TYPE === 'email' ? '*' : '' }}</label>
                        <input v-model="form.hoh.email_confirmation" class="uk-form-large uk-width-1-1" type="text"
                               placeholder="Confirm HH's Email" >
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="phone_number">
                        <label>{{ __('global.phone_number') }} </label>
                        <input v-model="form.hoh.phone" v-mask="'(###) ###-####'" class="uk-form-large uk-width-1-1"
                               type="text"
                               :placeholder=" __('global.phone_number')" >
                      </validated-section>
                    </div>

                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="phone_confirmation">
                        <label>{{ __('global.confirm')}} {{__('global.phone_number')}} </label>
                        <input v-model="form.hoh.phone_confirmation" v-mask="'(###) ###-####'"
                               class="uk-form-large uk-width-1-1" type="text"
                               :placeholder="__('global.confirm') + ' ' + __('global.phone_number')"/>
                      </validated-section>
                    </div>

                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="password">
                        <label>{{ __('global.password') }} *</label>
                        <input v-model="form.hoh.password" class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                               type="password" placeholder="Password(*)" name="question-9-password-1" required>
                        <div class="uk-text-danger">{{ getPasswordFieldMessage('password') }}</div>
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="password_confirmation">
                        <label>{{ __('global.confirm')}} {{__('global.password')}} *</label>
                        <input v-model="form.hoh.password_confirmation"
                               class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                               type="password" :placeholder="__('global.confirm') + ' ' + __('global.password')"
                               required>
                        <div class="uk-text-danger">{{ getPasswordFieldMessage('password_confirmation') }}</div>
                      </validated-section>
                    </div>
                    <div v-if="program.settings['show-ssn-registration']"
                         class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="ssn">
                        <label>{{ __('landing.ssn') }} <span
                            v-if="this.program.settings['require-applicant-social-security-number']"> *</span> </label>
                        <input v-model="form.hoh.ssn" @change="checkForDuplicateSocialSecurityNumber(form.hoh.ssn)"
                               v-mask="'###-##-####'" class="uk-width-1-1 uk-form-large uk-margin-small-bottom"
                               type="text" :placeholder="__('landing.ssn')" :disabled="form.hoh.use_hhmid_as_ssn">
                      </validated-section>
                      <div v-if="showHhmIdSsnCheckbox" class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                        <label><input v-model="form.hoh.use_hhmid_as_ssn" class="uk-checkbox" type="checkbox"> Use my unique ID number on this site as my SSN</label>
                      </div>
                    </div>
                    <div v-if="program.settings['show-ssn-registration']"
                         class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="ssn_confirmation">
                        <label>Confirm {{ __('landing.ssn') }} <span
                            v-if="this.program.settings['require-applicant-social-security-number']"> *</span></label>
                        <input v-model="form.hoh.ssn_confirmation" v-mask="'###-##-####'"
                               class="uk-width-1-1 uk-form-large uk-margin-small-bottom" type="text"
                               :placeholder="'Confirm ' + __('landing.ssn')" :disabled="form.hoh.use_hhmid_as_ssn">
                      </validated-section>
                    </div>

                  </div>
                </div>

                <div v-if="program.settings['show-hhms-registration']" v-for="(member, i) in householdMembers"
                     class="uk-width-1-1 uk-grid uk-grid-collapse uk-padding-remove household-member-wrapper" :key="member.id">
                  <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-margin-top uk-padding-remove">
                    <h3>Household Member {{ i + 2 }}:</h3>
                    <div><button @click="removeMember(i)">Remove</button></div>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom uk-padding-remove">
                    <div class="uk-grid">
                      <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                        <validated-section class="uk-width-1-1" :errors="errors" :field="'hh_data.'+i+'.first_name'">
                          <label for="">Household Member #{{ i + 2 }} First Name <span>*</span></label>
                          <input v-model="member.first_name" class="uk-form-large uk-width-1-1" type="text"
                                 placeholder="First Name" required>
                        </validated-section>
                      </div>
                      <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                        <validated-section class="uk-width-1-1" :errors="errors" :field="'hh_data.'+i+'.last_name'">
                          <label for="">Household Member #{{ i + 2 }} Last Name <span>*</span></label>
                          <input v-model="member.last_name" class="uk-form-large uk-width-1-1" type="text"
                                 placeholder="Last Name" required>
                        </validated-section>
                      </div>
                      <div v-if="program.settings['show-ssn-registration'] && program.settings['show-household-member-social']" class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                        <validated-section :errors="errors" :field="'hh_data.'+i+'.ssn'">
                          <label for="">Household Member #{{ i + 2 }} Social Security Number <span>*</span></label>
                          <input v-model="member.ssn" v-mask="'###-##-####'"
                                @change="checkForDuplicateSocialSecurityNumber(member.ssn, i)"
                                class="uk-form-large uk-width-1-1" type="text" placeholder="Social Security Number" :disabled="form.hoh.use_hhmid_as_ssn">
                        </validated-section>
                      </div>

                      <div class="uk-width-1-1 uk-width-medium-1-2">
                        <input type="checkbox" class="uk-margin-top " checked="true"> Is at Least 18 & Has
                        Income<span>*</span>
                      </div>
                    </div>

                  </div>

                  <hr class="uk-width-1-1 uk-margin-small uk-margin-bottom" :class="'hh-member-hr-'+i"/>
                </div>

                <div v-if="program.settings['show-hhms-registration']" class="uk-width-1-1 uk-padding-remove">
                  <button id="add-member-1" class="uk-button uk-button-mini uk-margin-bottom uk-width-1-1"
                     @click="addHouseholdMember">
                    ADD HOUSEHOLD MEMBER {{ this.householdMembers.length + 2 }}</button>
                </div>

                <div class=" uk-width-1-1 uk-align-center uk-margin-top uk-padding-remove">
                  <button
                      class="uk-button uk-button-large uk-width-small-1-1 uk-width-medium-9-10 uk-margin-bottom uk-align-center uk-animation-fade"
                      type="button" @click="submit" id="prequal-btn">
                    <i class="uk-icon-check-square-o"></i> {{ __('global.register') }}
                  </button>
                </div>


              </form>
            </div>

            <div v-if="showForm && application">
              <h2 class="uk-text-left">Congratulations!</h2>
              <p class="uk-text-left">
                Based on your answers, you have been prequalified. Please note that
                prequalifying does not guarantee approval for funding.
              </p>

              <p class="uk-margin-bottom">
                You must complete the remaining sections of this application.
                Failure to complete this application and provide the required documentation will
                prevent your application from consideration under the {{ program.program_abbreviation }} program. It is
                important
                to complete your application as soon as possible. Please enter the Head of Household’s registration
                information and create a password.
              </p>

              <h3>Your username is the email address provided by your landlord: {{application.user.username}}.</h3><h3>Please create a password <span v-if="program.settings['show-ssn-registration']">and enter your Social Security Number</span> to continue.</h3><h3>Please be sure to write down both your username and password in a secure location.</h3>

              <div class="uk-grid">
                <div class="uk-width-1-1 uk-width-medium-1-1 uk-margin-bottom">
                  <div class="uk-grid">
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="password">
                        <label>Password *</label>
                        <input v-model="form.hoh.password" class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                               type="password" placeholder="Password(*)" name="question-9-password-1" required>
                        <div class="uk-text-danger">{{ getPasswordFieldMessage('password') }}</div>
                      </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="password_confirmation">
                        <label>Confirm Password *</label>
                        <input v-model="form.hoh.password_confirmation"
                               class=" uk-form-large uk-width-1-1 uk-margin-small-bottom"
                               type="password" placeholder="Confirm Password(*)"
                               required>
                        <div class="uk-text-danger">{{ getPasswordFieldMessage('password_confirmation') }}</div>
                      </validated-section>
                    </div>
                    <div v-if="program.settings['show-ssn-registration']"
                         class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors" field="ssn">
                        <label>Social Security Number <span
                                v-if="this.program.settings['require-applicant-social-security-number']"> *</span> </label>
                        <input v-model="form.hoh.ssn" @change="checkForDuplicateSocialSecurityNumber(form.hoh.ssn)"
                               v-mask="'###-##-####'" class="uk-width-1-1 uk-form-large uk-margin-small-bottom"
                               type="text" placeholder="Social Security Number">
                      </validated-section>
                    </div>
                    <div v-if="program.settings['show-ssn-registration']"
                         class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-bottom">
                      <validated-section class="uk-width-1-1 uk-margin-small-bottom" :errors="errors"
                                         field="ssn_confirmation">
                        <label>Confirm Social Security Number <span
                                v-if="this.program.settings['require-applicant-social-security-number']"> *</span></label>
                        <input v-model="form.hoh.ssn_confirmation" v-mask="'###-##-####'"
                               class="uk-width-1-1 uk-form-large uk-margin-small-bottom" type="text"
                               placeholder="Confirm Social Security Number">
                      </validated-section>
                    </div>

                    <div class=" uk-width-1-1 uk-align-center uk-margin-top uk-padding-remove">
                      <button
                          class="uk-button uk-button-large uk-width-small-1-1 uk-width-medium-9-10 uk-margin-bottom uk-align-center uk-animation-fade"
                          type="button" @click="submitForApplication">
                        <i class="uk-icon-check-square-o"></i> CONTINUE TO MY APPLICATION
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="uk-grid" v-if="!application">
              <div class="uk-width-9-10 uk-align-center">
                <hr>
                <br/><button
                  class="uk-button uk-button-small  uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade"
                  @click="cancel"><i class="uk-icon-times-circle"></i> {{ __('global.cancel_pre_screen') }}</button>
              </div>
            </div>
          </div>
          <div class="uk-width-1-10">&nbsp;</div>


          <div id="prequal-list"
               class="uk-width-medium-3-10 uk-cover-background uk-row-first uk-overflow-container uk-height-viewport">
            <div class="uk-width-9-10 uk-align-center uk-margin-top">
              <a name="Answers"></a>
              <h3 class="uk-contrast" align="center">Pre-Screen Statements</h3>
              <hr/>
              <!-- these are the outputs for each prequalification question -->
              <div v-for="question in program.prequalification_questions" class="uk-contrast uk-grid"
                   v-show="answers[question.number] !== undefined" :key="question.number">
                <div class="uk-width-2-6 uk-margin-bottom"><i class="uk-icon-check-square-o"> </i>
                  {{ question.number }}<br/>
                  <small><button @click="editQuestion(question.number)" href="#questions-top">CHANGE</button></small>
                </div>
                <div class="uk-width-4-6 uk-margin-bottom">
                    <span v-if="answers[question.number] === 'yes'" v-html="question.statement"></span>
                    <span v-if="answers[question.number] === 'no'" v-html="question.statement_no"></span>
                    <span v-if="answers[question.number] === 'during' || answers[question.number] === 'due' || answers[question.number] === 'due_benefits'" v-html="question.statement"></span>
                </div>
                <div class="uk-width-1-1">
                  <hr/>
                </div>
              </div>
              <hr/>
              <div class="uk-alert uk-width-7-10 uk-align-center">
                <span v-if="this.program.settings['pre-qualification-note']">
                  {{ this.program.settings['pre-qualification-note'] }}
                </span>
                <span v-else>
                    {{ __('landing.prequal_knowingly_submitting') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vk-modal :show="showChangeModal" v-if="changeQuestion" stack>
      <h3>CHANGE ANSWER:</h3>
      <label>QUESTION:</label>
      <div>
        <div v-if="changeQuestion.type === 'income'">
          <income-question :states="states" :counties="counties" :program="program"
                           @proxyUpdated="form.fact_based_proxy = $event"
                           @addressVerified="updateVerifiedAddress"></income-question>
        </div>
        <div v-else class="uk-text-center" v-html="changeQuestion.body"></div>
      </div>
      <div class="uk-width-9-10 uk-align-center" v-if="changeQuestion.type !== 'income' || verifiedAddress !== null">
        <button class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
           @click="answerQuestion(changeQuestion.number,'yes');">
          <i class="uk-icon-square-o"></i> Yes</button>
        <button class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade"
           @click="answerQuestion(changeQuestion.number,'no');"><i class="uk-icon-square-o"></i> No</button>
      </div>
    </vk-modal>
  </div>

</template>

<script>
import IncomeQuestion from "./IncomeQuestion";
import HardshipQuestion from "./HardshipQuestion";
import ValidatedSection from "../../Common/ValidatedSection";
import {mapState} from "vuex";
import EventBus from "../../../../dashboard/EventBus";

export default {
  name: "PrequalificationForm",
  components: {ValidatedSection, IncomeQuestion, HardshipQuestion},
  props: ['program', 'states', 'counties', 'googleApiKey'],
  data() {
    return {
      application: null,
      showChangeModal: false,
      showFieldPartnerForm: true,
      usingFieldPartner: null,
      fieldPartnerId: null,
      fieldPartnerConfirmed: false,
      fieldPartnerLoading: false,
      noticeModal: null,
      modal: null,
      declineModal: null,
      changeQuestionId: null,
      currentQuestionNumber: 1,
      // answers: {1: 1, 2:2, 3:3, 4:4, 5:5, 6:6 }, // Dev
      answers: {},
      errors: {},
      formResponse: {},
      showDeclined: false,
      verifiedAddress: null,
      form: {
        fact_based_proxy: false,
        hoh: {
          index: 1,
          first_name: '',
          last_name: '',
          email: '',
          email_confirmation: '',
          username: '',
          username_confirmation: '',
          password: '',
          password_confirmation: '',
          phone: '',
          phone_confirmation: '',
          ssn: '',
          ssn_confirmation: '',
        }
      },
      householdMembers: [],
      isHomeless: false,
    }
  },
  computed: {
    showHhmIdSsnCheckbox() {
      return this.program.settings['show-ssn-registration'] && this.program.settings['use-hhm-id-as-ssn'] &&
        (
          !this.program.settings['require-applicant-social-security-number'] ||
          this.program.settings['require-applicant-social-security-number'] && this.errors['ssn']
        )
    },
    changeQuestion() {
      if (this.changeQuestionId === null) {
        return null;
      }

      return _.first(_.filter(this.program.prequalification_questions, q => q.number === this.changeQuestionId));
    },
    showForm() {
      return _.size(this.answers) === this.program.prequalification_questions.length;
    },
    ...mapState('Application', {
      applicantAddress: state => state.applicant.property_address,
    }),
    ...mapState('App', {
      env: state => state.env,
    }),
    currentQuestion() {
      return this.program.prequalification_questions.find(question => question.number === this.currentQuestionNumber)
    }
  },
  mounted() {
    this.isHomeless = false
    this.$store.dispatch('Prequalification/setProgram', this.program);
    this.$store.dispatch('Prequalification/setGoogleApiKey', this.googleApiKey);

    this.modal = UIkit.modal('#pre-qualify-form-vue', {escClose: false, bgClose: false, keyboard: false,});
    this.noticeModal = UIkit.modal('#notice-modal', {escClose: false});
    this.declineModal = UIkit.modal('#not-qualified-vue', {escClose: false});

    jQuery('.open-prequalify').click(() => {
      this.noticeModal.show();
    })

    document.getElementById('pre-qualify-form-button').addEventListener('click', () => {
      this.noticeModal.show();
      // this.modal.show();
    })
  },
  methods: {
    async checkFieldPartnerId() {
      this.fieldPartnerLoading = true;
      this.errors = {};
      try {
        let r = await axios.post('/api/check-field-partner', {pid: this.fieldPartnerId});
        this.fieldPartnerLoading = false;
        this.showFieldPartnerForm = false;
        this.$toast.success('Field Partner ID Verified.')
      }catch(e) {
        this.errors = e.response.data.errors;
        this.fieldPartnerLoading = false;
      }
    },
    setUsingFieldPartner(usingFieldPartner) {
      this.usingFieldPartner = usingFieldPartner;
      if(!usingFieldPartner) {
        this.showFieldPartnerForm = false;
      }
    },
    reset() {
      this.form = {
        hoh: {
          index: 1,
          first_name: '',
          last_name: '',
          email: '',
          email_confirmation: '',
          username: '',
          username_confirmation: '',
          password: '',
          password_confirmation: '',
          phone: '',
          phone_confirmation: '',
          ssn: '',
          ssn_confirmation: '',
          use_hhmid_as_ssn: false,
          fact_based_proxy: false,
        }
      };
      this.formResponse = {};
      this.answers = {};
      this.verifiedAddress = null;
      this.currentQuestionNumber = 1;
      this.showChangeModal = false;
      this.showDeclined = false;
      this.showFieldPartnerForm = true;
      this.usingFieldPartner = null;
    },
    showForApplication(application) {
      this.application = application;
      if (this.applicantAddress) {
        this.$set(this, 'verifiedAddress', _.cloneDeep(this.applicantAddress));
        EventBus.$emit('prequal.setVerifiedAddress', this.verifiedAddress);
      }
      this.modal.show({bgclose: false, escClose: false, keyboard: false});
    },
    showFormModal() {
      this.noticeModal.hide();
      this.modal.show();
    },
    addHouseholdMember() {
      this.householdMembers.push({
        index: this.householdMembers.length + 2,
        first_name: '',
        last_name: '',
        ssn: '',
        use_hhmid_as_ssn: false,
      })
    },
    removeMember(index) {
      this.householdMembers.splice(index, 1);
    },
    answerHardshipQuestion(questionNumber, answer, programId) {
      this.program.slug = programId;
      this.answerQuestion(questionNumber, answer);
    },
    answerQuestion(questionNumber, answer) {
      this.$set(this.answers, questionNumber, answer);
      this.changeQuestionId = null;
      this.showChangeModal = false;
      if (answer === 'no' && this.currentQuestion.fail_if_no) {
        console.log('Failing because question is no and fail_if_no is true')
        this.showDeclined = true;
      }else if(answer === 'yes' && this.currentQuestion.fail_if_yes) {
        console.log('Failing because question is yes and fail_if_yes is true')
        this.showDeclined = true;
      }

      const isHomeLessQuestion = this.program.settings['uses-prequal-question-designate-status'] ==  questionNumber
      if (isHomeLessQuestion)
      {
        this.isHomeless = answer === 'yes'
      }

      this.currentQuestionNumber = questionNumber + 1;

      this.$nextTick(() => {
        const focusableElements = (UIkit.Utils || UIkit.util).findFocusables(document.getElementById('pre-qual-questions'));

        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }
      })

    },
    updateVerifiedAddress(address) {
      this.verifiedAddress = address;
      this.findProgram(); //verifies there is a program that matches the inputed address and returns best matching program_id
    },
    async verifyProgramLocation(program_id) {
        //validate that the address is valid for this program
        let check = await axios.get('api/program/' + program_id + '/locations-check?state_id=' + this.verifiedAddress.state_id + '&city=' + encodeURI(this.verifiedAddress.city) + "&county_id=" + this.verifiedAddress.county_id + "&zip_code=" + this.verifiedAddress.zip + "&country_code=US");
        if(check.data.length > 0 && check.data === 'invalid') {
            this.showDeclined = true;
            return false;
        }
    },
    async findProgram() {
        if(this.env.WATERFALL_SITE){
            let prequal_yes_answer_btn = document.getElementById('prequal_yes_answer_btn');
            //prequal_yes_answer_btn.setAttribute('disabled', true);
            //find the best matching program id for this address
            let check = await axios.get('api/program/reverse-lookup?type=slug&state_id=' + this.verifiedAddress.state_id + '&city=' + encodeURI(this.verifiedAddress.city) + "&county_id=" + this.verifiedAddress.county_id + "&zip_code=" + this.verifiedAddress.zip + "&country_code=US");

            if(check.data.resp === -1) {

              // If the response comes back as -1, BUT ALL OF the following are true, do not show the decline screen
              // 1. The application already exists
              // 2. The application program has the option set to true for 'Allow application creation when program is closed'
              if(this.application && this.application.program && this.application.program.settings['allow-create-app-on-closed-program']) {
                return true;
              }
                this.showDeclined = true;
                return false;
            }

            //if the field partner id is null, then don't do reverse lookup
            if(this.fieldPartnerId !== null) {
                return null;
            }

            if(check.data.resp.length > 0) {
                this.program.slug = check.data.resp;
                //prequal_yes_answer_btn.removeAttribute('disabled');
            }
          }else{
          }
    },
    editQuestion(questionNumber) {
      this.changeQuestionId = questionNumber;
      if (this.changeQuestion.type === 'income') {
        this.verifiedAddress = null;
      }
      this.showChangeModal = true;
    },
    async validate() {
        if(this.form.hoh.email.length == 0 && this.form.hoh.phone.length == 0) {
            UIkit.modal.alert(`<p class="uk-modal-body">${this.__('validation.enter_valid_email')}</p>`).dialog;
            return false;
        }

        return true;
    },
    async submitForApplication() {
        // await this.validate();

        this.errors = {};

      let data = {
        password: this.form.hoh.password,
        password_confirmation: this.form.hoh.password_confirmation,
        ssn_confirmation: this.form.hoh.ssn_confirmation,
        ssn: this.form.hoh.ssn,
        prequal_answers: this.answers,
        address: this.verifiedAddress,
        username: this.form.hoh.username,
        username_confirmation: this.form.hoh.username_confirmation,
        use_hhmid_as_ssn: this.form.hoh.use_hhmid_as_ssn,
        fact_based_proxy: this.form.fact_based_proxy,
      }

      try {
        let r = await axios.post(`/api/hope/applications/${this.application.id}/prequal`, data);
        await this.$store.dispatch('Application/fetch', this.application.id);
        this.modal.hide();
      } catch (e) {
        this.errors = e.response.data.errors;
      }
    },
    async submit() {
        let valid = await this.validate();

        if(!valid) {
            return null;
        }

        this.errors = {};
      this.formResponse = {};


      if (_.size(this.errors) > 0) return;

      let hhData = [this.form.hoh];
      _.each(this.householdMembers, member => hhData.push(member));

      let prequalAnswers = this.answers;


      let data = {
        email: this.form.hoh.email,
        email_confirmation: this.form.hoh.email_confirmation,
        username: this.form.hoh.username,
        username_confirmation: this.form.hoh.username_confirmation,
        phone_number: this.form.hoh.phone,
        first_name: this.form.hoh.first_name,
        last_name: this.form.hoh.last_name,
        password: this.form.hoh.password,
        password_confirmation: this.form.hoh.password_confirmation,
        phone_confirmation: this.form.hoh.phone_confirmation,
        prequal_answers: prequalAnswers,
        hh_data: hhData,
        program_id: this.program.slug,
        address: this.verifiedAddress,
        using_field_partner: this.usingFieldPartner ? 1 : 0,
        field_partner_id: this.fieldPartnerId,
        use_hhmid_as_ssn: this.form.hoh.use_hhmid_as_ssn,
        is_homeless: this.isHomeless,
        fact_based_proxy: this.form.fact_based_proxy ? 1 : 0  ,
      };

      if(this.program.settings['show-ssn-registration']) {
        this.$set(data, 'ssn_confirmation', this.form.hoh.ssn_confirmation);
        this.$set(data, 'ssn', this.form.hoh.ssn);
      };

      //button loading
      let prequalBtn = document.getElementById('prequal-btn');
        prequalBtn.setAttribute('disabled', true);
        prequalBtn.innerHTML = '<i uk-spinner></i> PROCESSING';

      try {
        let r = await axios.post('/api/register', data);
        // return;
        window.location = r.data.login_url;
      } catch (e) {
          //reset button loading
          prequalBtn.removeAttribute('disabled');
          prequalBtn.innerHTML = '<i class="uk-icon-check-square-o"></i> REGISTER';
        this.errors = e.response.data.errors;
        this.formResponse = e.response.data;
        if (this.formResponse.user_exists) {
          UIkit.modal.confirm('<p class="uk-modal-body">It looks like you are already registered either by another family member, or your landlord. Please login to see your available applications.<br><br><a class="uk-button uk-button-primary" href="' + this.formResponse.login_url + '">Go to Login.</a></p>').dialog;
        }
      }
    },

    async setDisqualified() {
      if (this.application) {
        let r = await axios.post(`/api/hope/applications/${this.application.id}/set-disqualified`, {
          prequal_answers: this.answers,
        });
        window.location = '/logout';
      } else {
        this.cancel();
      }
    },

    cancel() {
      this.reset();
      this.modal.hide();
    },

    async checkForDuplicateEmailAddress(email, field) {
      this.errors = {};
      field = field || 'email';
      this.errors[field] = [];
      let data = {};
      data[field] = email;
      try {
        let r = await axios.post('/api/check-email', data);
      } catch (e) {
        this.errors = e.response.data.errors;
        UIkit.modal.alert("It looks like your are already registered either by another family member or your landlord. Please login to see your available applications. <br/><br/> You can log into the portal <a href='/login'>Here</a>.")
      }

    },

    async checkForDuplicateUsername(username, field) {

    },

    async checkForDuplicateSocialSecurityNumber(ssn, hhMemberId) {

      this.errors = {};
      let data = {}
      let field = 'ssn';
      if (hhMemberId === undefined) {
        data['ssn'] = ssn;
      } else {
        data['hh_data'] = {}
        data['hh_data'][hhMemberId] = {ssn};
        field = 'hh_data.' + hhMemberId + '.ssn';
      }

      this.errors[field] = [];

      try {
        let r = await axios.post('/api/check-ssn', data);
      } catch (e) {
        this.errors = e.response.data.errors;
        UIkit.modal.alert(this.__('validation.already_registered'))
      }

    },

    getPasswordFieldMessage(field) {
      let val = this.form.hoh[field];
      if (val.length > 0 && val.length < 15) {
        return this.__('validation.password_at_least_15')
      } else if (field == 'password_confirmation' && this.form.hoh.password != this.form.hoh.password_confirmation) {
        return this.__('validation.password_must_match')
      }
    },
  }
}
</script>
